import { FC } from 'react';
import { InfoTableRow, InfoTableRowProps } from './info-table-row';

export type InfoTableProps = {
  title: string;
  rows: InfoTableRowProps[];
};

export const InfoTable: FC<InfoTableProps> = ({ title, rows }) => (
  <div className="flex flex-col">
    <div className="border-b border-gray-200 pt-1.5 pb-2 text-base font-medium">
      {title}
    </div>
    {rows.map((row) => (
      <InfoTableRow key={row.label} {...row} />
    ))}
  </div>
);
